<template>
  <div class="print-box">
    <div class="print_header" v-show="!needPay">
      <div class="tip" v-show="!canPrint"><span></span>当前浏览器不支持打印功能，请您下载后自行打印，或使用Chrome、QQ浏览器打印</div>
    </div>
    <div class="print-btn-box">
      <el-button @click="goBack" size="small">返回
      </el-button>
      <el-button v-show="canPrint" @click="do_print" size="small" type="danger">打印</el-button>
      <el-button
        @click="downloadFile({targetId:fileInfo.targetId, fileType:fileInfo.fileType, sign:fileInfo.sign, ts:fileInfo.ts, fix: '.pdf'})"
        v-show="!canPrint" size="small" type="danger">下载
      </el-button>
      <el-button size="small" @click="printCordDialog = true">防伪打印记录</el-button>
    </div>
    <div class="file-list" v-if="this.fileList.length > 0">
      <div class="arr" @click="previous">
        <i class="el-icon-d-arrow-left"></i>
      </div>
      <div class="arr" @click="next">
        <i class="el-icon-d-arrow-right"></i>
      </div>
      <div class="main-box-tab-content" ref="tabs">
        <div class="main-box-tab-roll">
          <template v-for="(file, i) in fileList">
            <div :key="i" :class="actionName === file.fileId ? 'active': ''" @click="chooseFile(file)" class="list">
              <div class="bx">
                <img v-if="fileSuffix(file.fileName) === 'pdf'" src="/images/advancedVersion/pdf.png"/>
                <img v-if="fileSuffix(file.fileName) === 'wps'" src="/images/advancedVersion/WPS.png"/>
                <img v-if="fileSuffix(file.fileName) === 'jpg'" src="/images/advancedVersion/JPG.png"/>
                <img v-if="fileSuffix(file.fileName) === 'doc' || fileSuffix(file.fileName) === 'docx'"
                     src="/images/advancedVersion/word.png"/>
                <img v-if="fileSuffix(file.fileName) === 'xlsx' || fileSuffix(file.fileName) === 'xls'"
                     src="/images/advancedVersion/xlsx.png"/>
              </div>
              <p class="title" :title="file.fileName">{{file.fileName}}</p>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="contractBox" v-show="!needPay">
      <span class="icon"></span>
      <h3>{{detailInfo.contractName}}</h3>
      <p>防伪打印的文件中包含线上文件签署和文件防伪编码等的信息，可对应文件中的防伪编码查询操作账号。</p>
      <div id="printBox">
        <template v-for="item in convertInfo.items">
          <img :src="getFileUrl(item)" :key="'img_'+item">
          <div class="break_out" :key="'break_'+item"></div>
        </template>
        <template v-if="isMulti">
          <img :src="getOtherInfo()">
          <div class="break_out"></div>
        </template>
        <template v-else>
          <template v-for="item in pageSize">
            <img :src="getOtherInfo(item-1)" :key="'img_a_'+item">
            <div class="break_out" :key="'break_a_'+item"></div>
          </template>
        </template>
      </div>
    </div>
    <!--<h3 v-show="needPay" class="error_msg">已支付？点我刷新</h3>-->
    <!--防伪打印记录-->
    <el-dialog ref="addressBox" :visible.sync="printCordDialog" title="防伪打印记录" width="70%">
      <el-table :data="printList" tooltip-effect="dark">
        <el-table-column label="文件名称" prop="fileName" show-overflow-tooltip></el-table-column>
        <el-table-column label="文件哈希" prop="docHash" show-overflow-tooltip></el-table-column>
        <el-table-column label="防伪编码" prop="printNo" show-overflow-tooltip></el-table-column>
        <el-table-column label="时间" prop="createTime" show-overflow-tooltip></el-table-column>
        <el-table-column label="IP" prop="ip"></el-table-column>
        <el-table-column label="操作账号" prop="printer"></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
  import {
    ApiMethods,
    configUrl,
    postApplySignMultiInfo,
    postApplySignInfo,
    postCheckFilesStatus
  } from '@/assets/js/http-serve/http-methods';

  export default {
    data() {
      return {
        needPay: false,
        convertInfo: {},
        detailInfo: {},
        signStatus: null,
        fileInfo: {},
        canPrint: false,
        pageSize: 0,
        printLoading: null,
        printParams: {},
        iframe: null,
        // 903需求
        printList: [],
        fileList: [],
        printCordDialog: false,
        isMulti: false,
        moveX: 0,
        unoccupied: 0,
        tabsCount: 0,
        actionName: 0
      };
    },
    computed: {
      userType() {
        return this.$store.getters.currentAuthUser.superFlag == 0 || this.$store.getters.currentAuthUser.superFlag == 1 ? 1 : 0;
      },
    },
    watch: {
      actionName(val) {
        let len = this.fileList.length
        for (let i = 0; i < len; i++) {
          if (this.fileList[i].fileId === val) {
            this.$nextTick(() => {
              this.translateX((i + 1 - this.tabsCount) * this.width - this.unoccupied)
            })
            return
          }
        }
        this.$nextTick(() => {
          this.translateX((this.fileList.length - this.tabsCount) * this.width - this.unoccupied)
        })
      }
    },
    created() {
      let query = this.$route.query;
      postCheckFilesStatus(query).then(({data}) => {
        if (data.multiFiles) {
          this.isMulti = true
          ApiMethods.SignPrintController.getSignMulti(this.$route.query).then(res => {
            if (!res.success) return this.$message.error(res.description || '操作失败');
            this.printParams = res.data;
            this.printLoading = this.$loading({lock: true});
            this.getPrintMultiStatus();
          });
        } else {
          ApiMethods.SignPrintController.getSign(this.$route.query).then(res1 => {
            if (!res1.success) return this.$message.error(res1.description || '操作失败');
            this.printParams = res1.data;
            this.printLoading = this.$loading({lock: true});
            this.getPrintStatus();
            this.signPrintList();
          });
        }
      }).catch(err => {
        console.error('判断合同类型信息：' + JSON.stringify(err));
      });
    },
    mounted() {
      if (window.print) this.canPrint = true;
    },
    methods: {
      // 切换文件展示合同
      chooseFile(file) {
        if (this.actionName !== file.fileId) {
          this.actionName = file.fileId
        }
        this.contractList = {}
        let print = this.printList.find(v => v.fileId === file.fileId)
        this.printNo = print.printNo
        this.buildMultiPdf()
        this.convertContractToInfo(file)
      },
      // 获取文件后缀
      fileSuffix(fileName) {
        let first = fileName.lastIndexOf(".");//取到文件名开始到最后一个点的长度
        let namelength = fileName.length;//取到文件名长度
        let filesuffix = fileName.substring(first + 1, namelength);//截取获得后缀名
        return filesuffix
      },
      next() {
        let totalWidth = this.width * this.fileList.length
        this.$nextTick(() => {
          let dom = this.$refs.tabs
          if (dom.clientWidth < totalWidth && this.moveX + dom.clientWidth < totalWidth) {
            // this.moveX为0减去空余空间的宽度
            this.moveX += this.moveX ? this.width : this.width - this.unoccupied
            this.translateX(this.moveX)
          }
        })
      },
      previous() {
        if (this.moveX > 0) {
          this.moveX -= this.width
          this.translateX(this.moveX)
        }
      },
      translateX(x) {
        this.moveX = x < 0 ? 0 : x
        this.$refs.tabs.children[0].style.transform = `translateX(-${this.moveX}px)`
      },
      signPrintMultiList () {
        ApiMethods.SignPrintController.getSignMulti(this.$route.query).then(res1 => {
          if (!res1.success) return this.$message.error(res1.description || '操作失败');
          ApiMethods.SignPrintController.signMultiPrintList(Object.assign(res1.data, {
            itemPage: 1,
            pageSize: 1000,
            userType: this.userType,
          })).then(res => {
            if (!res.success) return this.$message.error(res.description || '操作失败');
            this.printList = res.data;
            let printNo = this.printList.find(v=>v.fileId === this.fileInfo.fileId)
            this.printNo = printNo.printNo
            this.buildMultiPdf()
          });
        });
      },
      // 防伪打印记录
      signPrintList() {
          ApiMethods.SignPrintController.getSign(this.$route.query).then(res1 => {
            if (!res1.success) return this.$message.error(res1.description || '操作失败');
            ApiMethods.SignPrintController.signPrintList(Object.assign(res1.data, {
              itemPage: 1,
              pageSize: 1000,
              userType: this.userType,
            })).then(res => {
              if (!res.success) return this.$message.error(res.description || '操作失败');
              this.printList = res.data;
            });
          });
      },
      buildPdf() {
        ApiMethods.SignPrintController.buildPdf({...this.printParams, printNo: this.printNo}).then(async res => {
          if (!res.sign || !res.targetId) return this.$message.error(res.description || '网络异常，请刷新重试');
          const response = await ApiMethods.FileOperController.show_get({...res, fix: '.pdf'});
          console.log(response)
          if (!response || !response.data) return;
          this.iframe = document.createElement('IFRAME');
          this.iframe.setAttribute('style', 'position:absolute;width:0px;height:0px;left:-500px;top:-500px;');
          this.iframe.setAttribute('src', URL.createObjectURL(response.data));
          document.body.appendChild(this.iframe);
        });
      },
      buildMultiPdf() {
        if(this.iframe) document.body.removeChild(this.iframe);
        ApiMethods.SignPrintController.buildMultiPdf({...this.printParams, printNo: this.printNo}).then(async res => {
          if (!res.sign || !res.targetId) return this.$message.error(res.description || '网络异常，请刷新重试');
          const response = await ApiMethods.FileOperController.show_get({...res, fix: '.pdf'});
          console.log(response)
          if (!response || !response.data) return;
          this.iframe = document.createElement('IFRAME');
          this.iframe.setAttribute('style', 'position:absolute;width:0px;height:0px;left:-500px;top:-500px;');
          this.iframe.setAttribute('src', URL.createObjectURL(response.data));
          document.body.appendChild(this.iframe);
        });
      },
      goBack() {
        this.$router.push({
          path: this.isMulti ? '/applySign/toDetailMultiAnony' : '/applySign/toDetailAnony', query: this.$route.query,
        });
      },
      // 多文件发起合同，做接口区分
      getPrintMultiStatus() {
        ApiMethods.SignPrintController.printMultiStatus(Object.assign(this.printParams,
          {userType: this.userType})).then(res2 => {
          if (!res2.success) return this.$message.error(res2.description || '操作失败');
          // this.printNo = res2.data.printNo;
          this.pageSize = res2.data.pageSize;
          if (res2.data.needPay) {
            this.needPay = true;
            this.$confirm(`需消耗${res2.data.point}积分,支付成功后24小时内可重复打印，超出时间后将再次收费。`, '支付提示', {
              showConfirmButton: true,
              showCancelButton: true,
              type: 'info',
            }).then(() => {
              ApiMethods.SignPrintController.orderMulti(Object.assign(this.printParams, {
                userType: this.userType,
                pay: 1,
                presId: this.$route.query.presId,
              })).then((res) => {
                if (+res.code === 10806) {
                  this.$jzqService.pointRechargeTip() // 积分不足时的充值提示
                  return;
                }
                if (+res.code === 0) {
                  this.needPay = false;
                  this.loadMultiData();
                  return;
                }
                this.$message.error(res.description || '支付失败');
              });
            });
          } else {
            this.needPay = false;
            this.loadMultiData();
          }
        }).finally(() => this.printLoading.close());
      },
      getPrintStatus() {
        ApiMethods.SignPrintController.printStatus(Object.assign(this.printParams,
          {userType: this.userType})).then(res2 => {
          if (!res2.success) return this.$message.error(res2.description || '操作失败');
          this.printNo = res2.data.printNo;
          this.pageSize = res2.data.pageSize;
          if (res2.data.needPay) {
            this.needPay = true;
            this.$confirm(`需消耗${res2.data.point}积分,支付成功后24小时内可重复打印，超出时间后将再次收费。`, '支付提示', {
              showConfirmButton: true,
              showCancelButton: true,
              type: 'info',
            }).then(() => {
              ApiMethods.SignPrintController.order(Object.assign(this.printParams, {
                userType: this.userType,
                pay: 1,
                presId: this.$route.query.presId,
              })).then((res) => {
                if (+res.code === 10806) {
                  this.$jzqService.pointRechargeTip() // 积分不足时的充值提示
                  return;
                }
                if (+res.code === 0) {
                  this.needPay = false;
                  this.loadData();
                  return;
                }
                this.$message.error(res.description || '支付失败');
              });
            });
          } else {
            this.needPay = false;
            this.loadData();
          }
        }).finally(() => this.printLoading.close());
      },
      getOtherInfo(num) {
        return this.isMulti ?
          ApiMethods.SignPrintController.showMulti(Object.assign(this.printParams, {num: 0, printNo: this.printNo})) :
          ApiMethods.SignPrintController.show(Object.assign(this.printParams, {num: num, printNo: this.printNo}))
      },
      getFileUrl(item) {
        const fileInfo = this.fileInfo;
        return ApiMethods.FileOperController.convertDetail_url(
          fileInfo.sign, fileInfo.ts, fileInfo.fileType, 'png', fileInfo.targetId, item, this.convertInfo.docHash || '');
      },
      async downloadFile(param) {
        let res = await ApiMethods.FileOperController.download_get(param);
        if (res.success && res.url) {
          window.location.href = res.url;
        } else {
          this.$message.error(res.err);
        }
      },
      loadData() {
        this.buildPdf();
        ApiMethods.ApplySignController.info(this.$route.query).then(result => {
          if (!result.success) {
            return this.$message.error(result.description || '初始化数据失败2');
          }
          if (result.data.signStatus === -6) {
            // 合同已过期，提示失效
            return this.$message.error('文件已过期');
          } else if (result.data.dealType === 6) {
            // hash只保全
            return this.$message.error('暂不支持Hash保全类型的文件');
          } else if (!result.data.fileInfo) {
            // 没有fileInfo（合同信息不存在）
            return this.$message.error('要查看的合同文件内容已不存在');
          }
          this.detailInfo = result.data;
          // 审核状态 -3 审核中
          this.signStatus = result.data.signStatus;
          this.fileInfo = result.data.fileInfo;

          ApiMethods.FileOperController.convertInfoNoFile(result.data.fileInfo).then(result => {
            if (!result.success) {
              return this.$message.error(result.description || '文件转换错误');
            }
            this.convertInfo = result.data;
            console.log(this.convertInfo)
          });
        });
      },
      // 多文件
      loadMultiData() {
        ApiMethods.ApplySignController.infoMulti(this.$route.query).then(result => {
          if (!result.success) {
            return this.$message.error(result.description || '初始化数据失败2');
          }
          if (result.data.signStatus === -6) {
            // 合同已过期，提示失效
            return this.$message.error('文件已过期');
          } else if (result.data.dealType === 6) {
            // hash只保全
            return this.$message.error('暂不支持Hash保全类型的文件');
          } else if (!result.data.fileInfos) {
            // 没有fileInfo（合同信息不存在）
            return this.$message.error('要查看的合同文件内容已不存在');
          }
          this.detailInfo = result.data;
          // 审核状态 -3 审核中
          this.signStatus = result.data.signStatus;
          this.fileList = result.data.fileInfos;
          this.fileInfo = result.data.fileInfos[0];
          this.actionName = result.data.fileInfos[0].fileId
          this.$nextTick(() => {
            let tabs = this.$refs.tabs
            let getStyle = getComputedStyle(tabs.children[0].children[0], null)
            let marginLeft = parseFloat(getStyle.marginLeft.substr(0, getStyle.marginLeft.length - 2))
            let marginRight = parseFloat(getStyle.marginRight.substr(0, getStyle.marginRight.length - 2))
            this.width = marginLeft + marginRight + tabs.children[0].children[0].offsetWidth
            this.unoccupied = tabs.offsetWidth % this.width
            // 转为整数
            this.tabsCount = parseInt(tabs.offsetWidth / this.width)
          })
          this.signPrintMultiList();
          this.convertContractToInfo(this.fileList[0])
        });
      },
      // 存储文件的合同文件转换，非上传的临时文件转换
      convertContractToInfo(param) {
        ApiMethods.FileOperController.convertInfoNoFile(param).then(({data}) => {
          this.convertInfo = data
        }).catch(err => {
          console.error('合同文件转换 ' + JSON.stringify(err));
        });
      },
      do_print() {
        this.iframe.contentWindow.focus();
        this.iframe.contentWindow.print();
        if (navigator.userAgent.indexOf('MSIE') > 0) {
          document.body.removeChild(this.iframe);
        }
      },
    },
    beforeDestroy() {
      document.body.removeChild(this.iframe);
    },
    layout: 'fullpage',
    head: {
      title: '防伪打印',
    },
  };
</script>
<style>
  .el-main {
    background-color: #ffffff;
  }
</style>
<style lang="less" scoped>
  .print-box {
    position: relative;
    width: 100%;
    height: auto;
  }

  .print-btn-box {
    position: fixed;
    right: 20px;
    top: 120px;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: space-between;
    min-height: 120px;
    width: 100px;
    z-index: 100;

    .el-button {
      width: 100%;
      margin: 0 5px;
    }
  }

  .file-list {
    width: 1200px;
    height: 200px;
    margin: 10px auto;
    background-color: #f5f5f5;
    position: relative;
    padding: 22px 50px;
    overflow: hidden;
    box-sizing: border-box;

    .arr {
      position: absolute;
      cursor: pointer;
      top: 50%;
      transform: translateY(-50%);
      width: 36px;
      height: 56px;
      background-color: #fff;
      font-size: 24px;
      font-weight: bold;
      line-height: 56px;
      text-align: center;
      color: #999999;
      box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.16);

      &:nth-child(1) {
        left: 0;
      }

      &:nth-child(2) {
        right: 0;
      }
    }

    .main-box-tab-content {
      overflow: hidden;

      .main-box-tab-roll {
        transition: transform .5s;
        display: flex;
        align-items: center;
        .list {
          flex-shrink: 0;
          cursor: pointer;
          width: 168px;
          height: 156px;
          margin: 0 15px;
          border-radius: 4px;
          overflow: hidden;
          border: 1px solid #E5E5E5;
          box-shadow: 0px 1px 6px rgba(0, 0, 0, 0.16);

          .bx {
            width: 100%;
            height: 116px;
            text-align: center;
            line-height: 128px;
            position: relative;

            img {
              height: 48px;
              width: auto;
            }
          }

          p.title {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            padding: 0 10px;
            background: #efefef;
            text-align: center;
            height: 40px;
            width: 100%;
            font-size: 14px;
            font-family: Source Han Sans SC;
            font-weight: 400;
            color: #290202;
            line-height: 40px;
          }
        }

        .list.active {
          border-color: #ec1c1c;
        }
      }
    }
  }

  .print_header {
    text-align: right;
    width: 100%;
    position: fixed;
    top: 60px;
    z-index: 100;
    left: 0;

    .tip {
      width: 100%;
      font-size: 14px;
      font-weight: 400;
      color: rgba(242, 96, 96, 1);
      height: 50px;
      line-height: 50px;
      background: rgba(255, 241, 241, 1);
      box-shadow: 0px 2px 8px rgba(209, 7, 7, 0.16);
      text-align: left;

      span {
        background: url("/static/images/icon/warn.png") no-repeat;
        width: 10px;
        height: 10px;
        background-size: cover;
        display: inline-block;
        margin: 0 10px;

      }
    }
  }

  .contractBox {
    width: 1200px;
    background: url("/static/images/bg_print.jpg");
    border: 1px solid rgba(250, 244, 244, 1);
    margin: 10px auto;
    position: relative;

    .icon {
      position: absolute;
      background: url("/static/images/bg_print_a.jpg") no-repeat;
      background-size: cover;
      width: 92px;
      height: 100px;
      top: -11px;
      left: 38px;
    }

    h3 {
      font-size: 30px;
      font-weight: bold;
      color: rgba(0, 0, 0, 1);
      text-align: center;
      margin-top: 101px;
      margin-bottom: 20px;
    }

    p {
      font-size: 16px;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.65);
      text-align: center;
      margin-bottom: 50px;
    }
  }

  #printBox {
    img {
      width: 1000px;
      margin: auto;
      display: block;
    }
  }

  .break_out {
    page-break-after: always;
    width: 100%;
    height: 20px;
  }

  .error_msg {
    text-align: center;
    font-size: 20px;
    margin-top: 50px;

  }

</style>



// WEBPACK FOOTER //
// pages/applySign/contractPrint.vue